// extracted by mini-css-extract-plugin
export var orderSearchResultCard = "_n-0";
export var skeletonCard = "_n-1";